import ReactModal from 'react-modal';
import { useAppSelector } from 'hooks/useAppSelector';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { closePopup } from 'store/config';
import { AgxButton } from '@urbanx/agx-ui-components';
import './Popup.scss';

interface PopupProps {
  selector: string;
}

const Popup = ({ selector }: PopupProps) => {
  const {
    popup: {
      id,
      open,
      title,
      body,
      onConfirm,
      buttonText: { close, confirm },
    },
  } = useAppSelector((state) => state.config);

  const dispatch = useAppDispatch();

  const popupStyles = {
    overlay: {
      backgroundColor: 'rgba(40,40,40, 0.75)',
    },
    content: {
      height: 'fit-content',
      width: 'fit-content',
      border: '1px solid #ccc',
      background: '#fff',
      borderRadius: '16px',
      outline: 'none',
      margin: '10rem auto',
    },
  };

  const RenderPopup = () => {
    return (
      <>
        <span
          className="absolute cursor-pointer text-lg text-gray-400 top-0 right-4 btn-x"
          onClick={() => dispatch(closePopup())}
        >
          x
        </span>
        {title && <h2 className="text-xl font-semibold text-center">{title}</h2>}
        {body && <p className="text-md text-center">{body}</p>}
        <div className="flex justify-center mt-4">
          {close && <AgxButton onClick={() => dispatch(closePopup())} text={close} />}
          {confirm && <AgxButton onClick={() => onConfirm && onConfirm()} text={confirm} />}
        </div>
      </>
    );
  };

  return (
    <ReactModal
      id={id}
      testId={id}
      style={popupStyles}
      parentSelector={() => document.querySelector(selector) || new HTMLElement()} //Portal
      ariaHideApp={false}
      isOpen={open}
      onRequestClose={() => dispatch(closePopup())}
    >
      <RenderPopup />
    </ReactModal>
  );
};

export default Popup;
